import { render, staticRenderFns } from "./FiscaisAndamentoDistribuicao.vue?vue&type=template&id=7fedea20&lang=pug&"
import script from "./FiscaisAndamentoDistribuicao.vue?vue&type=script&lang=js&"
export * from "./FiscaisAndamentoDistribuicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports